import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { filter, findIndex, includes, isNil, sortBy } from 'lodash';
import RecommendSearchWordSaveWrap from '../../../views/recommend/searchWord/save/RecommendSearchWordSaveWrap';
import { recommendSearchWordActions } from '../../../store/modules/recommend/searchWord';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../constants/service/common/utilConstants';
import {
  MINIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT,
  MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT,
  RECOMMEND_SEARCH_WORD_TYPE,
} from '../../../constants/service/app/recommendSearchWordConstants';
import { asyncSimpleModal } from '../../../lib/common';

class RecommendSearchWordSaveContainer extends Component {
  /**
   *  추천 검색 키워드 복사하기
   */
  onSubmit = () => {
    const { form, recommendSearchWordSave, createRecommendSearchWord } = this.props;
    const { recommendSearchWordInfo, recommendSearchWordItemList } = recommendSearchWordSave;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      /**
       *  추천 타입 선택 여부 체크
       */
      if (isNil(recommendSearchWordInfo.type)) {
        message.error('추천 타입을 선택해주세요.');
        return;
      }

      const maximumNumberOfRecommendSearchWordItemCount =
        MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[recommendSearchWordInfo.type];
      const minimumNumberOfRecommendSearchWordItemCount =
        MINIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[recommendSearchWordInfo.type];
      /**
       *  추천 검색 키워드 아이템 최소 개수 체크
       */
      if (
        minimumNumberOfRecommendSearchWordItemCount &&
        recommendSearchWordItemList.selectedItemList.list.length < minimumNumberOfRecommendSearchWordItemCount
      ) {
        message.error(`추천 검색 키워드 아이템은 최소 ${minimumNumberOfRecommendSearchWordItemCount}개이상입니다.`);
        return;
      } else if (
        /**
         *  추천 검색 키워드 타입이 인기 검색어인 경우에는
         *  아이템 개수가 무조건 10개로 설정이되어야 함.
         */
        recommendSearchWordInfo.type === RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP &&
        recommendSearchWordItemList.selectedItemList.list.length !== maximumNumberOfRecommendSearchWordItemCount
      ) {
        message.error(`인기 검색어는 ${maximumNumberOfRecommendSearchWordItemCount}개로 설정해야합니다..`);
        return;
      }

      createRecommendSearchWord({
        /**
         *  추천 검색 키워드 정보
         */
        recommendSearchWordInfo: {
          /**
           *  추천 검색 키워드 타입
           */
          type: recommendSearchWordInfo.type,
          /**
           *  메모
           */
          memo: recommendSearchWordInfo.memo,
        },
        /**
         *  추천 검색 키워드에 연결된 검색 키워드 id 리스트
         */
        recommendSearchWordItemIdList: recommendSearchWordItemList.selectedItemList.idList,
      });
    });
  };

  /**
   *  추천 검색 키워드에 연결할 아이템 리스트 불러오기
   */
  getRecommendSearchWordItemList = (option) => {
    const { getRecommendSearchWordItemList, recommendSearchWordSave } = this.props;
    const { recommendSearchWordItemList } = recommendSearchWordSave;
    const { filterOption, sortOption, pagination } = recommendSearchWordItemList.itemList;

    getRecommendSearchWordItemList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  추천 검색 키워드에 연결할 아이템 선택하기
   */
  selectRecommendSearchWordItemList = async (action, moveIdList) => {
    const { setData, recommendSearchWordSave } = this.props;
    const { recommendSearchWordInfo, recommendSearchWordItemList } = recommendSearchWordSave;
    const { itemList, selectedItemList } = recommendSearchWordItemList;

    /**
     *  업데이트 될 선택된 연결할 아이템 리스트
     */
    let updatedSelectRecommendSearchWordItemList = [];

    /**
     *  연결할 아이템 아이템 추가
     */
    if (action === 'add') {
      let targetList = filter(itemList.list, (item) => includes(moveIdList, item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 아이템을 합침
       */
      updatedSelectRecommendSearchWordItemList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 아이템 개수가 초과되었을 경우
       */
      if (
        updatedSelectRecommendSearchWordItemList.length >
        MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[recommendSearchWordInfo.type]
      ) {
        await asyncSimpleModal({
          type: 'error',
          title: '아이템 개수 초과',
          message: `추천 검색 키워드 아이템 개수는 최대 ${
            MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[recommendSearchWordInfo.type]
          } 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  연결할 아이템 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectRecommendSearchWordItemList = filter(
        selectedItemList.list,
        (item) => !includes(moveIdList, item.id),
      );
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedRecommendSearchWordItemList = itemList.list.map((item) => ({
      ...item,
      uncheckable: includes(moveIdList, item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['recommendSearchWordSave', 'recommendSearchWordItemList', 'itemList', 'list'],
      value: updatedRecommendSearchWordItemList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['recommendSearchWordSave', 'recommendSearchWordItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendSearchWordItemList,
        idList: updatedSelectRecommendSearchWordItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  추천 검색 리스트 아이템 순서 변경하기
   */
  onDragEndSelectRecommendSearchWordItemList = async (newList) => {
    const { setData, recommendSearchWordSave } = this.props;
    const { recommendSearchWordItemList } = recommendSearchWordSave;
    const { selectedItemList } = recommendSearchWordItemList;

    const updatedSelectRecommendSearchWordItemList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['recommendSearchWordSave', 'recommendSearchWordItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendSearchWordItemList,
        idList: updatedSelectRecommendSearchWordItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  전체 검색 키워드 리스트 EXCEL 다운로드
   */
  getRecommendSearchWordItemListExcelDownload = () => {
    const { getRecommendSearchWordItemListExcelDownload, recommendSearchWordSave } = this.props;
    const { recommendSearchWordItemList } = recommendSearchWordSave;
    const { filterOption, sortOption } = recommendSearchWordItemList.itemList;

    getRecommendSearchWordItemListExcelDownload({
      filterOption,
      sortOption,
    });
  };

  /**
   *  선택된 검색 키워드 리스트 EXCEL 다운로드
   */
  getSelectedRecommendSearchWordItemListExcelDownload = () => {
    const { getSelectedRecommendSearchWordItemListExcelDownload, recommendSearchWordSave } = this.props;
    const { recommendSearchWordItemList } = recommendSearchWordSave;
    const { idList } = recommendSearchWordItemList.selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getSelectedRecommendSearchWordItemListExcelDownload({
      selectedRecommendSearchWordItemIdList: idList,
    });
  };

  /**
   *  검색 키워드 리스트 EXCEL 업로드
   */
  setRecommendSearchWordItemListExcelUpload = (file) => {
    const { setRecommendSearchWordItemListExcelUpload, recommendSearchWordSave } = this.props;
    const { recommendSearchWordInfo } = recommendSearchWordSave;

    setRecommendSearchWordItemListExcelUpload({
      attachment: [file],
      recommendSearchWordType: recommendSearchWordInfo.type,
    });
  };

  render() {
    const { form, recommendSearchWordSave, setData, typeDisabled } = this.props;

    return (
      <RecommendSearchWordSaveWrap
        form={form}
        setData={setData}
        recommendSearchWordSave={recommendSearchWordSave}
        typeDisabled={typeDisabled}
        getRecommendSearchWordItemList={this.getRecommendSearchWordItemList}
        selectRecommendSearchWordItemList={this.selectRecommendSearchWordItemList}
        onSubmit={this.onSubmit}
        onDragEndSelectRecommendSearchWordItemList={this.onDragEndSelectRecommendSearchWordItemList}
        getRecommendSearchWordItemListExcelDownload={this.getRecommendSearchWordItemListExcelDownload}
        getSelectedRecommendSearchWordItemListExcelDownload={this.getSelectedRecommendSearchWordItemListExcelDownload}
        setRecommendSearchWordItemListExcelUpload={this.setRecommendSearchWordItemListExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    recommendSearchWordSave: state.recommendSearchWord.recommendSearchWordSave,
  };
};

const mapDispatchToProps = {
  setData: recommendSearchWordActions.setData,
  getRecommendSearchWordItemList: recommendSearchWordActions.getRecommendSearchWordItemList,
  createRecommendSearchWord: recommendSearchWordActions.createRecommendSearchWord,
  getRecommendSearchWordItemListExcelDownload: recommendSearchWordActions.getRecommendSearchWordItemListExcelDownload,
  getSelectedRecommendSearchWordItemListExcelDownload:
    recommendSearchWordActions.getSelectedRecommendSearchWordItemListExcelDownload,
  setRecommendSearchWordItemListExcelUpload: recommendSearchWordActions.setRecommendSearchWordItemListExcelUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(RecommendSearchWordSaveContainer));
